<div class="go-back">
	<a href="javascript:void(0)" (click)="returnBackClicked()">
		<i class="fa fa-arrow-left"></i>
		<span>{{ orderInboxModel && orderInboxModel.description }}</span>
	</a>
	<span class="form-type-badge badge bg-secondary">{{ orderInboxModel.formType }}</span>
	<span class="form-type-badge badge bg-secondary" *ngIf="orderInboxModel.externalProductName">{{ orderInboxModel.externalProductName }}</span>
	<span class="form-type-badge badge bg-secondary">Ref# : {{ orderInboxModel.externalId }}</span>
</div>
